import domReady from '@wordpress/dom-ready';
import tippy from 'tippy.js';

domReady(async () => {
	const tableSelector = '.js-pricing-table';
	const breakColumnOn = '.js-pricing-table-column-header';
	const featuredShadowSelector = '.js-featured-shadow';
	const featuredHeadingSelector = '.js-featured-heading';
	const featuredHeadingSpacerSelector = '.js-temp-spacer';
	const toggleSelector = '.js-toggle-component';

	const table = document.querySelectorAll(tableSelector);

	if (!table.length) {
		return;
	}

	const { PricingTableGridHelper } = await import('./pricingTableGridHelper');

	for (const tableElement of table) {
		const tableHelper = new PricingTableGridHelper({
			tableElement,
			breakColumnOn,
			featuredShadowSelector,
			featuredHeadingSelector,
			featuredHeadingSpacerSelector,
			toggleSelector,
		});

		tableHelper.init();

		// Tooltips
		const elementsWithTooltips = tableElement.querySelectorAll('[data-tooltip]');

		if (!elementsWithTooltips.length) {
			continue;
		}

		elementsWithTooltips.forEach((el) => {
			tippy(el.querySelector('.typography'), {
				content: el?.dataset?.tooltip ?? '',
				animation: 'shift-away',
				theme: 'translucent productive',
				maxWidth: 240,
			});
		});
	}
});
